import {
  PROFIL_GET,
  PROFIL_UPDATE,
  ACTIVATEEMAIL_PROFIL_UPDATE,
} from './reduxConstant';
import { createReducer } from '../../../App/common/utilities/reducerUtils';

const initialState = {
  profile: {},
  history: [],
  kelass: [],
  years: [],
  sems: [],
};

const profilGet = (state, payload) => {
  let data = payload.profil;
  let profile = data.profil;
  let history = data.history;
  let jenjangs = data.jenjangs;
  let kelass = data.kelass;
  let years = data.years;
  let sems = data.sems;
  return {
    ...state,
    profile: profile ? profile : state.profile,
    history: history ? history : state.history,
    jenjangs: jenjangs ? jenjangs : state.jenjangs,
    kelass: kelass ? kelass : state.kelass,
    years: years ? years : state.years,
    sems: sems ? sems : state.sems,
  };
};

const profilUpdate = (state, payload) => {
  return { ...state, ...payload.profil };
};

const activateEmailProfilUpdate = (state, payload) => {
  return {
    ...state,
    profile: {
      ...state.profile,
      username: payload.profil.username,
    },
  };
};

export default createReducer(initialState, {
  [PROFIL_GET]: profilGet,
  [PROFIL_UPDATE]: profilUpdate,
  [ACTIVATEEMAIL_PROFIL_UPDATE]: activateEmailProfilUpdate,
});
